<template>
    <div>
        <div class="sub-form">
            <div ref="form">
                <div>
                    <v-text-field
                            v-model="company_name"
                            label="Company Name"
                            outline
                            solo
                            :error-messages="companyErrors"
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                            v-model="user_name"
                            label="Employer Name"
                            outline
                            solo
                            :error-messages="nameErrors"
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                            v-model="email"
                            label="Email"
                            outline
                            solo
                            :error-messages="emailErrors"
                    ></v-text-field>
                </div>
                <div>
                    <v-text-field
                            v-model="phone"
                            label="Phone"
                            outline
                            solo
                            :error-messages="phoneErrors"
                    ></v-text-field>
                </div>
                <div v-if="!loading">
                    <button @click="handoverNow" style="width: 100%" class="btn btn-def">Submit</button>
                </div>
                <div v-else>
                    <v-btn
                            style="width: 100%"
                            :loading="loading"
                            :disabled="loading"
                    >
                        Submit
                    </v-btn>
                </div>
            </div>
        </div>
        <div>
            <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
                <div style="text-align: center; width: 100%">
          <span style="padding-right:1.0rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
                </div>
            </v-snackbar>
        </div>
    </div>
</template>

<script>
    import { validationMixin } from "vuelidate";
    import {
        required,
        minLength,
        maxLength,
        email,
        helpers
    } from "vuelidate/lib/validators";
    import {AUTO_SUGGEST_COMPANY_COMPLIANCE, CREATE_NEW_COMPANY, HANDOVER_COMPANY} from "../../../Api/admin_api";
    import {IsEmptyObject} from "../../../globalFunctions";
    const phone_validator = helpers.regex(
        "phone_validator",
        /^(?:\+?(?:88|01)?)(?:\d{11}|\d{13})$/
    );
    export default {
        name: "post-a-job",
        components: {},
        mixins: [validationMixin],
        validations: {
            user_name: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(64)
            },
            email: {
                required,
                email,
                minLength: minLength(4),
                maxLength: maxLength(64)
            },
            phone: {
                required,
                phone_validator,
                minLength: minLength(10),
                maxLength: maxLength(15)
            },
            company_name: {
                required
            }
        },
        data: function() {
            return {
                company_name: '',
                bgColor: "#454545",
                timeOut: 1000,
                snackbar: false,
                snackIcon: "",
                snackMessage: "",
                ripple: false,
                EmptyObject: IsEmptyObject,
                user_name: '',
                email: '',
                phone: '',
                loading: false
            };
        },
        methods: {
            resetAll(){
                const self = this;
                self.user_name = '';
                self.email = '';
                self.phone = '';
                self.company_name = '';
                self.$v.$reset();
            },
            handoverNow(){
                const self = this;
                self.$v.$touch();
                if (!self.$v.$anyError) {
                    self.loading = true;
                    let params = {
                        company_name: self.company_name,
                        user_name: self.user_name,
                        email: self.email,
                        phone: self.phone
                    };
                    CREATE_NEW_COMPANY(params).then(function (response) {
                        self.snackbar = true;
                        self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
                        self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
                        self.snackMessage = response.message;
                        self.loading = false;
                        self.resetAll()
                    }).catch(function (error) {
                        self.snackbar = true;
                        self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
                        self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
                        self.snackMessage = error.response.data.title;
                        self.loading = false;
                    })
                }
            },
        },
        computed: {
            companyErrors() {
                const errors = [];
                if (!this.$v.company_name.$dirty) return errors;
                !this.$v.company_name.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            },
            nameErrors() {
                const errors = [];
                if (!this.$v.user_name.$dirty) return errors;
                !this.$v.user_name.minLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.NAME);
                !this.$v.user_name.maxLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.NAME);
                !this.$v.user_name.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            },
            emailErrors() {
                const errors = [];
                if (!this.$v.email.$dirty) return errors;
                !this.$v.email.email &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.minLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.maxLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            },
            phoneErrors() {
                const errors = [];
                if (!this.$v.phone.$dirty) return errors;
                !this.$v.phone.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                !this.$v.phone.phone_validator &&
                errors.push(this.$constants.REQUIRED_MESSAGE.PHONE_INVALID);
                !this.$v.phone.minLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.PHONE_INVALID);
                !this.$v.phone.maxLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.PHONE_INVALID);
                return errors;
            },
        },
    };
</script>

<style scoped>
    .sub-form {
        max-width: 80rem;
        margin: auto;
    }
    .ttl-job {
        text-align: left;
        font-size: 1.6rem;
        color: #050505;
    }
    .ttl-inp {
        text-align: left;
        padding: 0.5rem 0;
    }
    .user-synops {
        background-color: #ffffff;
        text-align: left;
        padding: 2rem;
        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
        margin: 1rem 0;
    }
    .user-selected {
        text-align: left;
        max-width: 80rem;
        padding: 2rem;
        border: 1px solid #e6e6e6;
    }
    .ttl {
        font-size: 1.6rem;
    }
    .nm {
        font-size: 2rem;
        font-weight: bold;
        color: #050505;
    }
    .em {
        color: #3d4249;
    }
    .rl {
        font-size: 1.4rem;
        background-color: #0766ff;
        color: #ffffff;
        padding: 0 1rem;
        border-radius: 0.4rem;
    }
    .ag {
        background-color: #ff6e38;
    }
    .ad {
        background-color: var(--success);
    }
</style>
